import Annotation from "./annotation";

class RadialCircleGrid extends Annotation {
  constructor() {
    super();

    this.color = "#00b0f0";
    this.lineWidth = 1;
    this.scale = 0.70;
    this.canvasSize = null;
  }

  draw(ctx) {
    if (!this.canvasSize) 
      return;
    
      ctx.lineWidth = this.lineWidth;
      ctx.strokeStyle = this.color;
      ctx.fillStyle = this.color;

      let centerX = this.canvasSize.w / 2;
      let centerY = this.canvasSize.h / 2;
      let radius =  (this.canvasSize.h/2 - this.lineWidth) * this.scale;

      for (let i = 0; i <= 360; i += 30) {
        let radian = i * Math.PI/180
        ctx.beginPath();
        ctx.moveTo(centerX, centerY);
        ctx.lineTo(centerX + radius * Math.cos(radian), centerY + radius * Math.sin(radian));
        ctx.stroke();
        ctx.closePath();
      }

      ctx.beginPath();
      ctx.arc(centerX, centerY, radius - 3, 0, 2 * Math.PI);
      ctx.stroke();
      ctx.closePath();

      ctx.beginPath();
      ctx.arc(centerX, centerY, radius + 2, 0, 2 * Math.PI);
      ctx.stroke();
      ctx.closePath();

      ctx.beginPath();
      ctx.arc(centerX, centerY, radius - 8, 0, 2 * Math.PI);
      ctx.stroke();
      ctx.closePath();
  }
}

export default RadialCircleGrid;